
import * as Feature from "./featureStyles";

export default function FeatureContainer(){
    return (
    <Feature.Container>
        <Feature.TextOne>Hello, my name is</Feature.TextOne>
        <Feature.TextTwo>Brave,</Feature.TextTwo>
        <Feature.TextThree>Transforming ideas into efficient, scalable, and innovative digital solutions.</Feature.TextThree>
        {/* <Feature.TextFour>
            Passionate about building high-performance applications, optimizing system architectures, and crafting seamless user experiences. Dedicated to pushing technology forward through problem-solving and continuous innovation.
        </Feature.TextFour> */}
        {/* <Feature.Button href="/resume.pdf" target="__blank">
            Explore More
        </Feature.Button> */}
    </Feature.Container>
    )
}
